'use client'

import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { useEffect } from 'react'

/** `skip` hands body scroll control to another owner, e.g. the iOS swipe fullscreen flow. */
export const useFullscreenBodyStyle = (skip = false) => {
  const enableFull3d = useEnableFull3d()

  useEffect(() => {
    if (enableFull3d && !skip) {
      document.body.style.overflow = 'hidden'
      document.body.style.overscrollBehaviorY = 'auto'

      return () => {
        document.body.style.overflow = ''
        document.body.style.overscrollBehaviorY = ''
      }
    }
  }, [enableFull3d, skip])
}
